import React, {useState} from 'react';
import i18n, {resources} from './index';
import {findTranslationReferences} from './translationReferences';
import locations from './referenceLocations.json';

export default function TranslationReferenceFinder() {
    const [open, setOpen] = useState(false);
    const [query, setQuery] = useState('');
    const [status, setStatus] = useState('');
    const matches = open ? findTranslationReferences({baseline: resources.en, i18n, query, locations}) : [];
    const copy = async reference => {
        try {await navigator.clipboard.writeText(reference);setStatus(`Copied ${reference}`);}
        catch (_) {setStatus('Clipboard unavailable. Select and copy the key shown above.');}
    };
    return <div style={{marginTop: 12, color: '#fff', fontSize: 13}}>
        <button type="button" onClick={() => setOpen(!open)} style={button}>Dev · Find / copy translation key</button>
        {open && <section aria-label="Find translation key" style={{background: '#142235', border: '1px solid #82cfff', borderRadius: 8,
            maxHeight: '50vh', overflowY: 'auto', padding: 10, marginTop: 8}}>
            <p>Copy a key into Admin → Translations search. Search wording, a key, or a screen name.</p>
            <input aria-label="Find translation wording" autoFocus placeholder="e.g. Released or FolderListScreen" value={query}
                onChange={event => setQuery(event.target.value)} style={{...button, width: '100%', boxSizing: 'border-box'}} />
            {status && <p role="status">{status}</p>}
            {matches.slice(0, 100).map(item => <article key={item.reference} style={{padding: '12px 0', borderBottom: '1px solid #576476'}}>
                <strong style={{userSelect: 'text'}}>{item.reference}</strong><div>{item.english}</div>
                <pre style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', color: '#cbd3df'}}>{item.locations.join('\n') || 'No indexed call site'}</pre>
                <button type="button" style={button} onClick={() => copy(item.reference)}>Copy key</button>
            </article>)}
            {matches.length > 100 && <p>Showing 100 results. Narrow your search.</p>}
            {!matches.length && <p>{query.trim() ? 'No matching key. Report the phrase and screen; it may be hardcoded or supplied content.' : 'Enter a phrase to find its key.'}</p>}
            <button type="button" style={button} onClick={() => setOpen(false)}>Close finder</button>
        </section>}
    </div>;
}
const button = {color: '#fff', background: '#142235', border: '1px solid #82cfff', borderRadius: 6, padding: 8, cursor: 'pointer'};
